import script from "./MainDropdownMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MainDropdownMenu.vue?vue&type=script&setup=true&lang=js"

import "./MainDropdownMenu.vue?vue&type=style&index=0&id=50ec603d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50ec603d"]])

export default __exports__